import React, { useEffect, useState } from "react";
import { Button, Checkbox, Form, Input, message, Select } from "antd";
import "./sparepart_sales_customer.css";
import { useMonthOptions, useYearOptions } from "../../components/hoc_sparepart_sales_customer";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import saveAs from "file-saver";

const SparepartSalesCustomer: React.FC = () => {
    const [form] = Form.useForm();
    const { userData } = useAuth();
    const monthOptions = useMonthOptions();
    const yearOptions = useYearOptions();
    const [isDownloading, setIsDownloading] = useState(false);
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    useEffect(() => {
        const fetchWarehouse = async () => {
            if (userData && userData.kode_grup1) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sparepart-sales/warehouse/${userData.kode_grup1}`);
                    const warehouseName = response.data.warehouse_name;
                    form.setFieldsValue({ warehouse: warehouseName });
                } catch (error) {
                    console.error("Failed to fetch warehouse:", error);
                }
            }
        };

        fetchWarehouse();
    }, [userData, form]);

    const handleDownload = async () => {
        try {
            await form.validateFields(['periode_month', 'periode_year']);
            const { periode_month, periode_year, withoutSeNo, onlyOutstanding, onlySoNo } = form.getFieldsValue();

            if (!periode_month || !periode_year) {
                message.error("Please select both month and year.");
                return;
            }

            setIsDownloading(true);

            const monthStr = String(periode_month).padStart(2, '0');
            const yearStr = String(periode_year).slice(-2);
            const fileName = `ReportSalesCustomer${monthStr}${yearStr}.xlsx`;

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/sparepart-sales/export`, {
                params: {
                    month: periode_month,
                    year: periode_year,
                    kode_grup1: userData?.kode_grup1,
                    withoutSeNo: withoutSeNo || false,
                    onlyOutstanding: onlyOutstanding || false,
                    onlySoNo: onlySoNo || false,
                },
                responseType: 'blob',
            });

            saveAs(new Blob([response.data]), fileName);

        } catch (error: any) {
            if (error.response && error.response.status === 404) {
                message.error("No data found for the selected period and warehouse.");
            } else {
                message.error("Failed to download report. Please try again.");
                console.error("Download error:", error);
            }
        } finally {
            setIsDownloading(false);
        }
    };


    return (

        <div id="ilqt" style={transformStyle}>
            <div className="gjs-grid-row" id="iri3">
                <div className="gjs-grid-column" id="icd1">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="sparepart-sales-customer"
                        form={form}
                    >
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="Loading warehouse..." readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Periode Month"
                            name="periode_month"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder="Select a month"
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    ...(monthOptions || []),
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={!monthOptions}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Periode Year"
                            name="periode_year"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Select
                                showSearch
                                placeholder="Select a year"
                                optionFilterProp="label"
                                options={[
                                    { value: "", label: "--  Empty --" },
                                    ...(yearOptions || []),
                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                loading={!yearOptions}
                            />
                        </Form.Item>
                        <Form.Item name="withoutSeNo" valuePropName="checked" wrapperCol={{ offset: 5, span: 16 }} style={{ marginBottom: "5px", marginLeft: '100px' }}>
                            <Checkbox>Only SE NO</Checkbox>
                        </Form.Item>
                        <Form.Item name="onlyOutstanding" valuePropName="checked" wrapperCol={{ offset: 5, span: 16 }} style={{ marginBottom: "5px", marginLeft: '100px' }}>
                            <Checkbox>Only Outstanding</Checkbox>
                        </Form.Item>
                        <Form.Item name="onlySoNo" valuePropName="checked" wrapperCol={{ offset: 5, span: 16 }} style={{ marginBottom: "5px", marginLeft: '100px' }}>
                            <Checkbox>Only SO No</Checkbox>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{ offset: 5, span: 16 }}
                            style={{
                                marginBottom: "5px",
                                marginLeft: '100px'
                            }}
                        >
                            <Button
                                type="primary"
                                onClick={handleDownload}
                                loading={isDownloading}
                            >
                                Download
                            </Button>
                        </Form.Item>
                    </Form>

                </div>
            </div>
        </div>
    );
};

export default SparepartSalesCustomer;